import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http'


@Injectable({
  providedIn: 'root'
})
export class AuthService implements HttpInterceptor{

  private currentUserSubject: BehaviorSubject<any>;

  constructor(private http: HttpClient,
    private injector: Injector,
    private _snackBar: MatSnackBar) { 
      this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('User')));
    }

  public get currentUserValue() {
    return this.currentUserSubject.value;
  }

  loggedIn(): boolean{
    // return true;
    return !!localStorage.getItem('token');
  }

  intercept(req, next) {
    let token = JSON.parse(localStorage.getItem('token'));
    // let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55X2lkIjoxMjQ1LCJlbWFpbCI6ImthdmluNDEzNDU2N0BnbWFpbC5jb20iLCJleHAiOjE2MTMwNDM0MTAsImZpcnN0X25hbWUiOiJrYXZpbjEiLCJpZCI6MSwibGFzdF9uYW1lIjoic2hhcm1hMiIsInBob25lIjoiMTIzNDU2NzgiLCJyb2xlcyI6WyJyb290Il19.d6hodkPHFXc2gVJ2B_OTtEyhB6A1fR7r1kk2O34nB0s'
    let authService = this.injector.get(AuthService)
    let tokenizedReq = req.clone(
      {
        headers: req.headers.set('Authorization', 'Bearer ' + token)
      }
    )
    return next.handle(tokenizedReq)
  }
  

  login(data) {
    return this.http.post<any>(`${environment.apiUrl}/auth/v1/login`, data).
      pipe(map(user => {
        if (user && user.authorization) {
          let objectToSave = {
            ...user,
            timeStamp: new Date()
          }
          localStorage.setItem('token', JSON.stringify(user.authorization));
          localStorage.setItem('User', JSON.stringify(objectToSave));
          this.currentUserSubject.next(objectToSave);
        }
        else {
          this._snackBar.open('Only Admins and Store Managers can login !', 'OK', { duration: 3000 })
        }
        return user;
      }));
  }

  signup(data){
    return this.http.post<any>(`${environment.apiUrl}/auth/v1/signup`, data).
      pipe(map(user => {
        if (user && user.AuthToken) {
          let objectToSave = {
            ...user,
            timeStamp: new Date()
          }
          localStorage.setItem('token', JSON.stringify(user.AuthToken));
          localStorage.setItem('User', JSON.stringify(objectToSave));
          this.currentUserSubject.next(objectToSave);
        }
        else {
          this._snackBar.open('Successfully Registered but Only Admins and Store Managers can login !', 'OK', { duration: 3000 })
        }
        return user;
      }));
  }
}


